import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import ArrowForward from '@mui/icons-material/ArrowForward';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import { useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';


function ProductCategoryIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  // const [searchTerm, setSearchTerm] = useState('');
  // const [filteredData, setFilteredData] = useState([]);
  const history = useHistory(); // Access the navigation history

  const { isAuthenticated, companyId, permissions, token, logout } = useAuth();
  const hasCreateMasterPermission = permissions.includes('Create Master');
  const hasEditMasterPermission = permissions.includes('Edit Master');
  const hasDeleteMasterPermission = permissions.includes('Delete Master');

  useEffect(() => {
    // Check if the token is expired
    if (isAuthenticated && tokenIsExpired(token)) {
      // Token is expired, log out the user
      logout();
      return;
    }

    // Token is not expired, fetch data
    fetchtableData();
  }, [isAuthenticated, companyId, token, logout]);

  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  //handle search
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  //search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const fetchtableData = async () => {
    fetchData('ProductCategoryApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode === '1111') {
          setData(response.response_data);

        }
      })
      .catch((error) => {
        console.error('Error fetching Item Details:', error);
        // Handle error, e.g., redirect to login if token is expired
        if (error.response && error.response.status === 401) {
          logout();
          // Redirect to login with the current location as a parameter
          history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
        }
      });
  };




  const handleDeleteConfirmation = () => {
    handleDelete(deleteItemId);
  };


  const handleActivate = (itemId) => {
    activateData('ProductCategoryApi', `${itemId}`)
      .then(() => {
        fetchtableData();
      })
      .catch((error) => {
        console.error('Error activating record:', error);
      });
  };
  const handleDelete = async () => {
    try {
      await deleteData('ProductCategoryApi', `${deleteItemId}`, token);
      fetchtableData();
      setDeleteItemId(null);
      setConfirmDialogOpen(false);
    } catch (error) {
      console.error('Error deleting record:', error);
    }
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };
  // Define initial column order
  const [columnOrder, setColumnOrder] = useState([

    'Sl.No',
    'Name',
    'Description',
    ...(hasCreateMasterPermission ? ['Action'] : [''])

  ]);

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto">

      <div className="w-full mb-2 flex flex-col md:flex-row md:items-center">
        <h6
          className="uppercase tracking-wide text-black flex-grow linkcolor"
          style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>
          Category
        </h6>

        <div className="mt-2 md:mt-0 flex justify-center md:justify-end items-center">
          <SearchIcon
            onClick={toggleSearchInput}
            style={{ cursor: 'pointer' }}
          />
          {showSearchInput && (
            <input
              className="shadow appearance-none border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline ml-2 mt-2 md:mt-0 md:ml-3 w-3/4 md:w-48"
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
            />
          )}
        </div>
        {hasCreateMasterPermission && (
          <Tooltip title="Create Product Category">
            <Link to="/ProductCategoryCreate" className="inline-block">
              <Button
                style={{
                  background: 'linear-gradient(to right, darkslategray, slategray)',
                  borderRadius: '50px',
                  padding: '10px 20px',
                  color: 'white',
                  fontWeight: 'bolder',
                  textTransform: 'none',
                  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                  maxHeight: '35px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <AddIcon style={{ fontWeight: 'bolder' }} /> Create
              </Button>
            </Link>
          </Tooltip>
        )}

      </div>



      <div className='w-full mb-5 flex' style={{ maxHeight: '540px', overflowY: 'auto', marginTop: '-0.20%' }}>

        <TableContainer component={Paper}>
          <Table>
            {/* <TableHead sx={{ backgroundColor: '#0B5345' }}>
              <TableRow>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '20px', color: 'white' }}>Sl.No</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '70px', color: 'white' }}>Name</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '250px', color: 'white' }}>DescriptionDescription</TableCell>
                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bolder', fontSize: '16px', padding: '7px', textAlign: 'center', width: '70px', color: 'white' }}>Actions</TableCell>
              </TableRow>
            </TableHead> */}
            <TableHead sx={{
              backgroundColor: 'teal',
              position: 'sticky',
              top: 0,
              zIndex: 1, width: '2000px'
            }}>
              <TableRow>
                {columnOrder.map((col, index) => (
                  <TableCell
                    key={index}
                    style={{
                      padding: '6px',
                      cursor: 'move',
                      color: 'white',
                      fontWeight: 'bold',

                    }}

                  >
                    {col}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            {/* <TableBody style={{ backgroundColor: 'white' }}>
            
              {filteredData.map((item, index) => (
                <TableRow key={item.Id}>
                  <TableCell sx={{ fontSize: '14px', padding: '3px', borderBottom: '1px solid #FFE1E2', textAlign: 'center', width: '20px' }}>{index + 1}</TableCell>
                  <TableCell sx={{ fontSize: '14px', padding: '3px', borderBottom: '1px solid #FFE1E2', textAlign: 'center', width: '70px' }}>{item.name}</TableCell>
                  <TableCell sx={{ fontSize: '14px', padding: '3px', borderBottom: '1px solid #FFE1E2', textAlign: 'center', width: '250px' }}>{item.description}</TableCell>
                  <TableCell sx={{ fontSize: '14px', padding: '3px', borderBottom: '1px solid #FFE1E2', textAlign: 'center', width: '70px' }}>

                   {hasEditMasterPermission && ( 
                    <Link to={`/ProductCategoryEdit/${item.id}`}>
                      <Tooltip title="Edit ProductCategory">
                        <IconButton>
                          <EditIcon style={{ color: '#4682B4' }} />
                        </IconButton>
                      </Tooltip>
                    </Link>
                   )} 
                   {hasDeleteMasterPermission && (
                   
                    <Tooltip title="Delete ProductCategory">
                      <IconButton onClick={() => (item.isActive ? openConfirmDialog(item.id) : handleActivate(item.id))}>
                        {item.isActive ? <DeleteIcon style={{ color: 'brown' }} /> : <ActivateIcon />}
                      </IconButton>
                    </Tooltip>

                )}

                  </TableCell>
                </TableRow>
              ))}
            </TableBody> */}
            <TableBody>
              {Array.isArray(filteredData) && filteredData.length > 0 ? (
                filteredData.map((rowData, index) => {
                  const rowValues = {
                    'Sl.No': index + 1,
                    'Name': rowData.name || '',
                    'Description':rowData. description || '',
                    'Action': (
                      <>
                        {hasEditMasterPermission && (
                          <Link to={`/ProductCategoryEdit/${rowData.id}`}>
                            <Tooltip title="Edit ProductCategory">
                              <IconButton>
                                <EditIcon style={{ color: 'darkgoldenrod' }} />
                              </IconButton>
                            </Tooltip>
                          </Link>
                        )}

                        {hasDeleteMasterPermission && (
                          <Tooltip title={rowData.isActive ? 'Delete BagMaster' : 'Activate BagMaster'}>
                            <IconButton
                              onClick={() =>
                                rowData.isActive
                                  ? openConfirmDialog(rowData.id)
                                  : handleActivate(rowData.id)
                              }
                            >
                              {rowData.isActive ? (
                                <DeleteIcon style={{ color: 'brown' }} />
                              ) : (
                                <ActivateIcon />
                              )}
                            </IconButton>
                          </Tooltip>
                        )}
                      </>
                    ),
                  };

                  return (
                    <TableRow key={index}>
                      {Object.keys(rowValues).map((key) => (
                        <TableCell
                          key={key}
                          sx={{
                            fontSize: '14px',
                            padding: '5px',
                            textAlign: 'left',
                            width: '20px',
                          }}
                        >
                          {rowValues[key]}
                        </TableCell>
                      ))}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={3} sx={{ textAlign: 'center' }}>
                    No data available.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
            {/* Delete confirmation dialog */}
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <button onClick={closeConfirmDialog} className="cancelbutton">
                  Cancel
                </button>
                <button onClick={handleDelete} className="confirmbutton">
                  Confirm
                </button>
              </DialogActions>
            </Dialog>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
}


export default ProductCategoryIndex;

